<template>
  <b-form-group
    label="Ürün Kategorisi"
    label-for="itemid"
  >
    <v-select
      id="itemid"
      v-model="itemData.itemid"
      :options="dataList"
      label="title"
      :reduce="item => item.id"
      placeholder="Seçiniz"
    >
      <template v-slot:option="option">
        <div>
          {{ option.title }}
        </div>
        <div>
          <small class="text-warning">{{ option.main_category }}</small>
        </div>
      </template>
    </v-select>
  </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'ServiceCategories',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    dataList() {
      return this.$store.getters['productGroups/dataList']
    },
    itemData() {
      return this.$store.getters['menus/dataItem']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('productGroups/getDataList', {
        where: {
          'product_categories.id_product_categories !=': null,
        },
      })
    },
  },
}
</script>
